import { Link } from 'react-router-dom';
import { useActiveStores } from '@/hooks/useActiveStores';
import { useAppSelector } from '@/hooks/useAppSelector';

export function PosStorePicker() {
  const selected = useAppSelector((s) => s.app.selectedStore);
  const { stores, loading } = useActiveStores();

  if (selected) return null;

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
      <h2 className="text-xl font-semibold text-slate-800 dark:text-slate-100">Select company and store to continue</h2>
      <p className="max-w-md text-sm text-slate-600 dark:text-slate-400">
        Choose your company, then your store from the header dropdowns. Billing, inventory, shifts, and returns all
        run in that company and store context.
      </p>
      {!loading && stores.length === 0 && (
        <p className="text-sm text-amber-700 dark:text-amber-400">
          No active stores yet.{' '}
          <Link to="/pos/stores" className="font-medium text-primary-600 hover:underline">
            Create a store
          </Link>{' '}
          first.
        </p>
      )}
    </div>
  );
}
